import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
} from '@azure/msal-browser';
import {
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import { environment } from '../../environments/environment';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;
/**
 * Here we pass the configuration parameters to create an MSAL instance.
 * For more info, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/configuration.md
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.authConfig.credentials.clientId,
      authority:
        'https://login.microsoftonline.com/' + environment.authConfig.credentials.tenantId,
      redirectUri: environment.authConfig.configuration.redirectUri,
      postLogoutRedirectUri: environment.authConfig.configuration.postLogoutRedirectUri
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
  });
}

/**
 * MSAL Angular will automatically retrieve tokens for resources
 * added to protectedResourceMap. For more info, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/initialization.md#get-tokens-for-web-api-calls
 */
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  //NOTE: [dturco 03.27.2025] When we set a protectResource and the scope is NULL this acts as an unprotect resource. No JWT will be added to the header
  protectedResourceMap.set(environment.APIEndPointExternal, null);
   //NOTE: [dturco 03.24.2025] This is TEMP and needs to be removed once the API is updated to use the new API endpoint.
  //This goes because its a set and any duplicate key will be updated. For lower environments we use the same api url as APIEndPoint
  protectedResourceMap.set(environment.APIEndPointRefData, environment.authConfig.resources.apiScopes);
  environment.authConfig.routes.forEach(r => {
    const fullRoute = environment.APIEndPoint + r;
    protectedResourceMap.set(fullRoute, environment.authConfig.resources.apiScopes);
  });
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

/**
 * Set your default interaction type for MSALGuard here. If you have any
 * additional scopes you want the user to consent upon login, add them here as well.
 */
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: environment.authConfig.resources.apiScopes
    }
  };
}
